import "../styles/Expertise.css";
import expertiseImg from "../images/Experties.png";

export default function ExpertiseSection() {
  return (
    <section className="expertise-section">

      <div className="container">

        <div className="expertise-wrapper">

          {/* IMAGE */}
          <div className="expertise-image">
            <img src={expertiseImg} alt="AC Manufacturing Facility" />
          </div>

          {/* CONTENT */}
          <div className="expertise-content">

            <h2>Expertise in High-Quality AC Assembly</h2>

            <p>
              Jat Technocraft Pvt. Ltd. is a professionally managed air conditioner
              manufacturing and job work organization established in 2015,
              located in MIDC Waluj, Aurangabad.
            </p>

            <p>
              With advanced infrastructure, certified quality processes,
              and a skilled workforce of 100+ employees, we specialize in
              high-quality AC assembly and OEM manufacturing services.
            </p>

            {/* TAGS */}
            <div className="expertise-tags">
              <span>Advanced Manufacturing Facility</span>
              <span>Process-Oriented Production</span>
              <span>Quality & SOP Compliance</span>
              <span>Experienced Engineering Team</span>
            </div>

            {/* STATS */}
            <div className="expertise-stats">

              <div>
                <h3>2015</h3>
                <p>Established</p>
              </div>

              <div>
                <h3>100+</h3>
                <p>Employees</p>
              </div>

              <div>
                <h3>500+</h3>
                <p>Units / Month</p>
              </div>

              <div>
                <h3>100%</h3>
                <p>Compliance</p>
              </div>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
}